module.exports = __webpack_public_path__ + "er.svg?cadb5e5ab2f4d9ac0485acc824f1cf52";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/er.svg
// module id = 800
// module chunks = 27